/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/DataReliabilitySection.tsx.
 */

import React from "react";
import "../UserHome.css";

const DataReliabilitySection: React.FC = () => {
  return (
    <div className="user-home-section">
      <div className="user-info-card">
        <h3 className="user-info-card-title">Data reliability framework</h3>
        <p className="user-info-card-text">
          To ensure transparency and scientific rigour, all datasets in ICoMEC are screened using a data reliability framework. Datasets that meet ICoMEC's reliability thresholds are classified as reliable data.
        </p>
        <p className="user-info-card-text">
          Reliability is assessed based on:
        </p>
        <div className="user-info-list">
          <p className="user-info-card-text"><strong>Data Review:</strong></p>
          <p className="user-info-card-text">External or internal review status</p>
          <p className="user-info-card-text"><strong>Data Acquisition Method:</strong></p>
          <p className="user-info-card-text">Measured, estimated, or modeled data</p>
          <p className="user-info-card-text"><strong>Data Completeness:</strong></p>
          <p className="user-info-card-text">Coverage across life-cycle stages (A1-A3 or aggregated)</p>
        </div>
      </div>
    </div>
  );
};

/** React component — Data Reliability Section. */
export default DataReliabilitySection;
